import { render, staticRenderFns } from "./BasalsTableModule.vue?vue&type=template&id=6b5ef85a&scoped=true"
import script from "./BasalsTableModule.vue?vue&type=script&lang=js"
export * from "./BasalsTableModule.vue?vue&type=script&lang=js"
import style0 from "./BasalsTableModule.vue?vue&type=style&index=0&id=6b5ef85a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5ef85a",
  null
  
)

export default component.exports